import React from 'react';
import classNames from 'classnames';

import { useConfiguration } from '../../context/configurationContext';

import css from './Logo.module.css';

// Merrily bunting pennant SVG icon
const BuntingIcon = ({ className }) => (
  <svg className={className} width="28" height="24" viewBox="0 0 48 44" fill="none">
    <path d="M4 6 L14 6 L9 22 Z" fill="#FBCE5C" opacity="0.9"/>
    <path d="M13 6 L23 6 L18 22 Z" fill="#CC4733" opacity="0.9"/>
    <path d="M22 6 L32 6 L27 22 Z" fill="#3E816D" opacity="0.9"/>
    <path d="M31 6 L41 6 L36 22 Z" fill="#E8D8F5" opacity="0.9"/>
    <line x1="2" y1="6" x2="44" y2="6" stroke="#D4BFA8" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="2" cy="6" r="1.5" fill="#D4BFA8"/>
    <circle cx="44" cy="6" r="1.5" fill="#D4BFA8"/>
  </svg>
);

/**
 * Merrily logo — bunting icon + Lobster Two wordmark.
 * `compact` collapses the wordmark on mobile (used by the sticky topbar to
 * distinguish itself from the footer logo on long pages).
 */
export const LogoComponent = props => {
  const { className, layout, compact, ...rest } = props;
  const logoClasses = className || css.root;

  return (
    <div className={classNames(logoClasses, css.merrilyLogo)}>
      <BuntingIcon className={css.buntingIcon} />
      <span className={classNames(css.wordmark, { [css.wordmarkCompact]: compact })}>
        merrily
      </span>
    </div>
  );
};

const Logo = props => {
  const config = useConfiguration();
  const { layout = 'desktop', ...rest } = props;

  return <LogoComponent {...rest} layout={layout} />;
};

export default Logo;
